import {Routes} from 'constants/routes';

import {useEffect, useMemo, useState} from 'react';

import {setStepAC} from 'features/postGenerator/slice';
import {postGeneratorSteps} from 'features/postGenerator/typescript';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate} from 'react-router';

import {getAllBeersACS} from '../requestAC';
import './ListBeers.scss';
import {setAllBeersAC, setAllBeersFilterAC} from '../slice';
import {BeerListTable} from './BeerListTable/BeerListTable';
import {BeersPubHeader} from './BeersPubHeader/BeersPubHeader';

const ListBeers = () => {
  const dispatch = useSetGlobalState();
  const navigate = useNavigate();

  const {allBeerFilter, pubBeers} = useGlobalState((state) => state.beersManager);

  const [isInputFocused, setIsInputFocused] = useState(false);

  useEffect(() => {
    dispatch(getAllBeersACS(allBeerFilter));
    // eslint-disable-next-line
  }, [allBeerFilter]);
  useEffect(() => {
    return () => {
      dispatch(setAllBeersFilterAC({page: 1, perPage: 8, name: ''}));
      dispatch(setAllBeersAC([]));
    };
    // eslint-disable-next-line
  }, []);

  const beersPubHeader = {setIsInputFocused, allBeerFilter, isInputFocused};

  const handlePostRedirect = () => {
    dispatch(setStepAC(postGeneratorSteps.postType));
    navigate(Routes.POST_GENERATOR);
  };

  const isTapEmpty = useMemo(
    () => pubBeers.length === 0 || pubBeers.every((beer) => !beer.attributes.on_tap),
    [pubBeers],
  );

  return (
    <div className="list-beers">
      {isInputFocused && <div className="list-beers__curtain" />}
      <BeersPubHeader {...beersPubHeader} />
      <BeerListTable />
      <div className="list-beers__action">
        <button title="new post" onClick={handlePostRedirect} disabled={isTapEmpty}>
          +
        </button>
        <span>New Post</span>
      </div>
    </div>
  );
};

export default ListBeers;
